import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import ProductList from '../viewsDash/ProductList.vue'
import store from '@/store'
import { cookieAuth } from '@/api/user'

Vue.use(VueRouter)

const siteBaseName = 'PrintIt CP'
const titleBase = ` — ${siteBaseName}`
const routes: Array<RouteConfig> = [
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/error-pages/404.vue'),
    meta: { hidden: true, title: `404` }
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: '',
      requiresAuth: false,
      title: `Anmelden`
    },
    component: () => import(/* webpackChunkName: "routes" */ `@/views/OutsideDashboard.vue`),
    // redirect if already signed in
    beforeEnter: async (to, from, next) => {
      if (to.path.startsWith('/public/')) {
        next()
      } else if (store.getters.authorized) {
        next('/dashboard')
      } else {
        await store.dispatch('cookieLogin')

        // const { data } = await cookieAuth()
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        //@ts-ignore
        if (store.state.authorized) {
          next('/dashboard')
        } else {
          next()
        }
      }
    },
    children: [
      {
        path: '',
        component: () => import(`@/components/LoginForm.vue`)
      }
    ]
  },
  {
    path: '/dashboard',
    name: 'Home',
    component: Dashboard,
    //make sure we are authorized
    beforeEnter: async (to, from, next) => {
      if (store.getters.authorized) {
        next()
      } else {
        await store.dispatch('cookieLogin')
        // check if we have cookie.
        // send cookie to server
        //const { data } = await cookieAuth()
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        //@ts-ignore
        if (store.state.authorized) {
          next()
        } else {
          next('/')
        }
      }
    },
    children: [
      {
        path: '/dashboard',
        name: 'Übersicht',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "dashboard" */ '@/viewsDash/Dashboard.vue'),
        meta: {
          icon: 'mdi-view-dashboard',
          iconColor: 'blue',
          title: `Dashboard`
        }
      },
      {
        path: '/product/list',
        name: 'Produktliste',
        component: ProductList,
        meta: {
          icon: 'mdi-format-list-bulleted',
          iconColor: 'pink',
          title: `Produktliste`
        }
      },
      {
        path: '/product/new',
        name: 'NewProduct',
        component: () => import(/* webpackChunkName: "product" */ '@/viewsDash/Product.vue'),
        meta: {
          hidden: true,
          title: `Produkt anlegen`
        }
      },
      {
        path: '/product/edit/:id',
        name: 'EditProduct',
        component: () => import(/* webpackChunkName: "productEdit" */ '@/viewsDash/Product.vue'),
        meta: {
          hidden: true,
          title: `Produkt editieren`
        }
      },
      {
        path: '/product/summary/:id',
        name: 'ProductSummary',
        component: () => import(/* webpackChunkName: "productSummary" */ '@/viewsDash/ProductSummary.vue'),
        meta: {
          hidden: true,
          title: `Produktübersicht`
        }
      },
      // {
      //   path: '/icons',
      //   name: 'Icons',
      //   component: () => import(/* webpackChunkName: "icons" */ '../viewsDash/Icons.vue'),
      //   meta: {
      //     keepAlive: true, //keepAlive will keep the site in cache and prevent reloading. will not call created() anymore, use different methods! (i think activated/deactivated, look it up)
      //     icon: 'mdi-playlist-star'
      //   }
      // },
      {
        path: '/customers',
        name: 'Kunden',
        component: () => import(/* webpackChunkName: "customers" */ '../viewsDash/Customers.vue'),
        meta: {
          keepAlive: false, //keepAlive will keep the site in cache and prevent reloading. will not call created() anymore, use different methods! (i think activated/deactivated, look it up)
          icon: 'mdi-account-multiple',
          iconColor: 'orange',
          title: `Kunden`
        }
      },
      {
        path: '/orders',
        name: 'Bestellungen',
        component: () => import(/* webpackChunkName: "orders" */ '../viewsDash/Orders.vue'),
        meta: {
          keepAlive: false, //keepAlive will keep the site in cache and prevent reloading. will not call created() anymore, use different methods! (i think activated/deactivated, look it up)
          icon: 'mdi-clipboard-text-outline',
          iconColor: 'green',
          title: `Bestellungen`
        }
      },
      {
        path: '/order/summary/:id',
        name: 'Bestellung',
        component: () => import(/* webpackChunkName: "orders" */ '@/viewsDash/OrderSummary.vue'),
        meta: {
          hidden: true,
          keepAlive: false, //keepAlive will keep the site in cache and prevent reloading. will not call created() anymore, use different methods! (i think activated/deactivated, look it up)
          iconColor: 'green',
          title: `Bestellungsübersicht`
        }
      },
      {
        path: '/settings',
        name: 'Einstellungen',
        component: () => import(/* webpackChunkName: "settings" */ '../viewsDash/Settings.vue'),
        meta: {
          keepAlive: false, //keepAlive will keep the site in cache and prevent reloading. will not call created() anymore, use different methods! (i think activated/deactivated, look it up)
          icon: 'mdi-cog',
          iconColor: 'grey',
          title: `Einstellungen`
        }
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: () => import(/* webpackChunkName: "settings" */ '../viewsDash/Notification.vue'),
        meta: {
          keepAlive: false, //keepAlive will keep the site in cache and prevent reloading. will not call created() anymore, use different methods! (i think activated/deactivated, look it up)
          hidden: true,
          title: `Benachrichtigungen`
        }
      }
    ]
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "error" */ '@/views/error-pages/404.vue'),
    meta: { hidden: true, title: `404` }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)

  store.state.title = nearestWithTitle.meta.title
  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title + titleBase

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router
